import { useMutation, useQueryClient } from '@tanstack/react-query';
import AuthApi from '@/auth/api/authApi';
import { UserResponse } from '@/schema/user';
import { JwtResponse, LoginRequest, RegisterRequest } from '../schema/auth';

// Login mutation
export const useLogin = () => {
  return useMutation<JwtResponse, Error, LoginRequest>({
    mutationFn: (data) => AuthApi.login(data),
  });
};

// Register mutation
export const useRegister = () => {
  return useMutation<UserResponse, Error, RegisterRequest>({
    mutationFn: (data) => AuthApi.register(data),
  });
};

// Refresh token mutation (usually done on app load or retry)
export const useRefreshToken = () => {
  return useMutation<JwtResponse>({
    mutationFn: () => AuthApi.refresh(),
  });
};

// Logout mutation
export const useLogout = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => AuthApi.logout(),
    onSuccess: () => {
      queryClient.clear(); // optional: clears all cached user data
    },
  });
};
